import { ADMIN_ROLES } from '../../../roles';

export const navData= 
[{
    routeLink:'/dashboard',
    icon:'fas fa-home',
    Label:"Dashboard",
  allowedUserTypes:[...ADMIN_ROLES]

},
{
    routeLink:'/vendor-submissions',
    icon:'fas fa-file-alt',
    Label:"Forms",
  allowedUserTypes:[...ADMIN_ROLES]
},
// {
//   routeLink: '/registrationform',
//   iconClass: 'material-icons',
//   iconName: 'badge',
//   Label:"Registration",
//     allowedUserTypes: ['Vendor']
// },
{
  routeLink: '/registrationform',
  icon: 'fas fa-id-card',
  Label:"Registration",
    allowedUserTypes: ['Vendor']
},
{
  routeLink: '/messages',
  icon: 'fas fa-envelope-open-text',
  Label: 'Messages',
  allowedUserTypes: ['Vendor']
},
// {
//   routeLink: '/requests',
//   icon:'fal fa-inbox',
//   Label:"Requests",
//   allowedUserTypes:['Admin']
// },
{
    routeLink: '/accounts',
    icon:'fas fa-users',
    Label:"Vendors",
    allowedUserTypes:[...ADMIN_ROLES]
},
{
  routeLink: '/profile',
  icon:'fas fa-user-circle',
  Label:"My Profile",
  allowedUserTypes:[...ADMIN_ROLES, 'Vendor']
},
{
  routeLink: '/faq',
  icon:'fas fa-question-circle',
  Label:"FAQ & Support",
  allowedUserTypes:[...ADMIN_ROLES, 'Vendor']
},
{
  routeLink: '/admin',
  icon:'fas fa-eye',
  Label:"Admin Hub",
    allowedUserTypes: [...ADMIN_ROLES]
},
]




export const configOption =
{
    routeLink: '/',
    icon:'fal fa-sign-out',
    Label:"Log Out"
   
}
